const apiBase = (process.env.REACT_APP_API_BASE_URL ?? "").trim();

export const AppConfig = {
    /** Backend API base URL (no trailing slash). Used by axios client and services. */
    apiBaseUrl: apiBase,
    /** @deprecated Use apiBaseUrl. Kept for compatibility. */
    superUserDashboardBaseUrl: apiBase + "/api",
};

function normalizeWebSocketBase(input: string): string | null {
    const t = input.trim().replace(/\/+$/, "");
    if (!t) return null;
    if (t.startsWith("ws://") || t.startsWith("wss://")) return t;
    try {
        const u = new URL(t);
        const wsProto = u.protocol === "https:" ? "wss:" : "ws:";
        return `${wsProto}//${u.host}`;
    } catch {
        return null;
    }
}

/**
 * WebSocket origin (`wss://host` or `ws://host`).
 * Uses `REACT_APP_WS_BASE_URL` when set; otherwise derives from `REACT_APP_API_BASE_URL`.
 * In the browser, falls back to the current page host when those are missing or invalid.
 */
export function getWebSocketBaseUrl(): string {
    const fromWsEnv = normalizeWebSocketBase(process.env.REACT_APP_WS_BASE_URL ?? "");
    if (fromWsEnv) return fromWsEnv;

    const fromApi = normalizeWebSocketBase(apiBase);
    if (fromApi) return fromApi;

    if (typeof window === "undefined") {
        return "";
    }
    const wsProto = window.location.protocol === "https:" ? "wss:" : "ws:";
    return `${wsProto}//${window.location.host}`;
}
